import {connect} from "react-redux"
import State from "../../models/state"
import {PublishRemoveFromFav, PublishAddToFav} from "../../events"
import {getListId} from "../../utils/getWindowNextFavourites"
import {setFavouritedColourways, setLoadingFav, setAnimateFavouriteIcon} from "../../ducks/productSummary"
import {PublishToModalsClosed} from "../../events/modalsClosed"
import {formatFavouritesTitleAndLabel} from "../../utils/colourwayBuilders"
import getRealmFromHeaders from "../../utils/getRealmFromHeaders"

export const mapStateToProps = ({productSummary, text, request}: State, ownProps) => {
    const {
        isFav,
        showFavErrorToolTip,
        enabledSearchDesc,
        isLoadingFav,
        animateFavouriteIcon,
        summaryData: {id, baseUrl, colourways, fit, department},
    } = productSummary
    const {isEnglishLang, headers} = request

    const selectedColourwayTitle = colourways.find(colourway => colourway.s)?.t
    const selectedColourway = colourways.find(colourway => colourway.s)

    return {
        isFav,
        itemNumber: id,
        showFavErrorToolTip,
        baseUrl,
        colourways,
        enabledSearchDesc,
        fit,
        department,
        isLoadingFav,
        text,
        animateFavouriteIcon,
        realm: getRealmFromHeaders(headers),
        favouriteButtonTitleAndLabel: formatFavouritesTitleAndLabel({
            isEnglishLang,
            text,
            selectedColourwayTitle,
            defaultTitle: selectedColourwayTitle ?? "",
            selectedColourway,
            fit,
            isFav,
        }),
        ...ownProps,
    }
}

const addToFavourites = () => (dispatch, getState) => {
    const state = getState()
    dispatch(setLoadingFav(true))
    dispatch(setAnimateFavouriteIcon(true))
    PublishToModalsClosed()
    const eventId = Date.now().toString()
    const listId = getListId()
    const data = {
        itemNumber: state.productSummary.summaryData.colourways.find(colourway => colourway.s)?.id,
        listId,
        optionCode: -1,
        eventId,
    }
    dispatch(PublishAddToFav(data))
}

const removeFromFavourites = () => (dispatch, getState) => {
    const state = getState()
    dispatch(setLoadingFav(true))
    dispatch(setAnimateFavouriteIcon(true))
    PublishToModalsClosed()
    const eventId = Date.now().toString()
    const listId = getListId()
    const data = {
        itemNumber: state.productSummary.summaryData.colourways.find(colourway => colourway.s)?.id,
        listId,
        optionCode: -1,
        eventId,
    }
    dispatch(PublishRemoveFromFav(data))
}

export const mapDispatchToProps = dispatch => ({
    addToFavourites: () => {
        dispatch(addToFavourites())
    },
    removeFromFavourites: () => {
        dispatch(removeFromFavourites())
    },
    setFavouritedColourways: (favouritedColourways: string[]) =>
        dispatch(setFavouritedColourways(favouritedColourways)),
})

export default connect(mapStateToProps, mapDispatchToProps)
